(() => {
  const formatMoneyId = (value) => {
    const number = Number(value) || 0;
    return `Rp ${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  };

  const initPriceSlider = (form) => {
    const host = form.querySelector('#flat-slider, .flat-slider');
    const fromInput = form.querySelector('.filter-group-display__price-range-from input');
    const toInput = form.querySelector('.filter-group-display__price-range-to input');
    if (!host || !fromInput || !toInput || host.dataset.ready) return;

    const max = Number(toInput.getAttribute('max') || fromInput.getAttribute('max') || 0);
    const minVal = Number(fromInput.value || 0);
    const maxVal = Number(toInput.value || max);

    host.innerHTML = `
      <div class="ci-collection-price-slider__track"></div>
      <div class="ci-collection-price-slider__range"></div>
      <input type="range" min="0" max="${max}" value="${minVal}" step="1" data-ci-price-min aria-label="Minimum price">
      <input type="range" min="0" max="${max}" value="${maxVal}" step="1" data-ci-price-max aria-label="Maximum price">
    `;
    host.dataset.ready = 'true';
    host.classList.add('ci-collection-price-slider');

    const rangeEl = host.querySelector('.ci-collection-price-slider__range');
    const minRange = host.querySelector('[data-ci-price-min]');
    const maxRange = host.querySelector('[data-ci-price-max]');
    const minLabel = form.querySelector('.flex-price-range .min-price');
    const maxLabel = form.querySelector('.flex-price-range .max-price');

    const sync = () => {
      let min = Number(minRange.value);
      let maxCurrent = Number(maxRange.value);
      if (maxCurrent - min < 1) {
        if (document.activeElement === minRange) {
          minRange.value = String(Math.max(0, maxCurrent - 1));
          min = Number(minRange.value);
        } else {
          maxRange.value = String(Math.min(max, min + 1));
          maxCurrent = Number(maxRange.value);
        }
      }

      const percentMin = max > 0 ? (min / max) * 100 : 0;
      const percentMax = max > 0 ? (maxCurrent / max) * 100 : 100;
      if (rangeEl) {
        rangeEl.style.left = `${percentMin}%`;
        rangeEl.style.right = `${100 - percentMax}%`;
      }

      fromInput.value = String(min);
      toInput.value = String(maxCurrent);
      if (minLabel) minLabel.textContent = formatMoneyId(min);
      if (maxLabel) maxLabel.textContent = formatMoneyId(maxCurrent);
    };

    const submitPrice = () => {
      form.submit();
    };

    minRange.addEventListener('input', sync);
    maxRange.addEventListener('input', sync);
    minRange.addEventListener('change', submitPrice);
    maxRange.addEventListener('change', submitPrice);
    sync();
  };

  // Sold-out products always sit at the bottom of the grid. Every page is already
  // ordered server side (collection-showing.liquid); this keeps the sold-out cards
  // of earlier Ajaxinate pages below the available cards of the pages loaded later.
  const moveSoldOutLast = (loop) => {
    if (!loop) return;
    loop.querySelectorAll(':scope > [data-soldout="true"]').forEach((cell) => loop.appendChild(cell));
  };

  const initCollection = (scope = document) => {
    const sections = scope.querySelectorAll('[data-ci-collection]');
    sections.forEach((section) => {
      if (section.dataset.ciReady) return;
      section.dataset.ciReady = 'true';

      const sidebar = section.querySelector('[data-ci-collection-sidebar]');
      const products = section.querySelector('[data-ci-collection-products]');
      const overlay = document.querySelector('[data-ci-collection-overlay]');
      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

      const syncProductCols = () => {
        if (!products || !sidebar) return;
        const collapsed = sidebar.classList.contains('ci-collection-sidebar--collapsed');
        products.classList.toggle('ci-collection-products--full', collapsed || isMobile());
      };

      const isDrawerSidebar = sidebar && sidebar.classList.contains('ci-collection-sidebar--drawer-only');

      section.querySelectorAll('[data-ci-filter-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!sidebar) return;
          if (isMobile() || isDrawerSidebar) {
            sidebar.classList.toggle('is-open');
            document.body.classList.toggle(
              'ci-collection-scroll-lock',
              sidebar.classList.contains('is-open')
            );
            if (overlay) {
              overlay.classList.toggle('is-visible', sidebar.classList.contains('is-open'));
            }
          } else {
            sidebar.classList.toggle('ci-collection-sidebar--collapsed');
            syncProductCols();
          }
        });
      });

      const closeMobile = () => {
        if (!sidebar) return;
        sidebar.classList.remove('is-open');
        document.body.classList.remove('ci-collection-scroll-lock');
        if (overlay) overlay.classList.remove('is-visible');
      };

      section.querySelectorAll('[data-ci-filter-close]').forEach((btn) => {
        btn.addEventListener('click', closeMobile);
      });
      if (overlay) overlay.addEventListener('click', closeMobile);

      // Accordion: each filter type toggles open/closed (Prestige custom.js)
      section.querySelectorAll('.filter-group-display').forEach((display) => {
        const group = display.closest('.filter-group');
        if (group && group.hasAttribute('open')) {
          display.style.display = '';
        } else {
          display.style.display = 'none';
        }
      });

      section.querySelectorAll('.filter-group-summary').forEach((summary) => {
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const group = summary.closest('.filter-group');
          if (!group) return;
          const display = group.querySelector('.filter-group-display');
          if (group.hasAttribute('open')) {
            group.removeAttribute('open');
            if (display) display.style.display = 'none';
          } else {
            group.setAttribute('open', '');
            if (display) display.style.display = '';
          }
        });
      });

      // Auto-submit on filter select (no Apply button) — same as current theme
      const form = section.querySelector('.filter-form');
      if (form) {
        if (!form.getAttribute('method')) form.setAttribute('method', 'get');
        if (!form.getAttribute('action')) {
          form.setAttribute('action', window.location.pathname);
        }

        form.querySelectorAll('.filter-group-display__list input').forEach((input) => {
          input.addEventListener('change', () => form.submit());
        });

        initPriceSlider(form);
      }

      const sortSelect = section.querySelector('#ci-collection-sort-by, .ci-collection-sort-by, #SortBy');
      if (sortSelect) {
        sortSelect.addEventListener('change', function onSortChange() {
          const params = new URLSearchParams(window.location.search);
          params.set(this.name, this.value);
          window.location = `?${params.toString()}`;
        });
      }

      const productList = section.querySelector('.ci-collection-product-list');
      section.querySelectorAll('[data-ci-layout-switch]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const gridType = btn.getAttribute('data-grid-type');
          const count = btn.getAttribute('data-count');
          if (!gridType || !count || !productList) return;

          const attrs = {};
          if (gridType === 'mobile') {
            attrs.collection_mobile_items_per_row = count;
          } else {
            attrs.collection_desktop_items_per_row = count;
          }

          try {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ attributes: attrs }),
            });
          } catch (e) {
            /* persist preference locally even if cart update fails */
          }

          if (gridType === 'mobile') {
            productList.style.setProperty('--ci-collection-cols-mobile', count);
            productList.dataset.mobileCount = count;
          } else {
            productList.style.setProperty('--ci-collection-cols-desktop', count);
            productList.dataset.desktopCount = count;
          }

          section.querySelectorAll(`[data-ci-layout-switch][data-grid-type="${gridType}"]`).forEach((switchBtn) => {
            switchBtn.classList.toggle('is-active', switchBtn === btn);
          });
        });
      });

      syncProductCols();
      window.addEventListener('resize', syncProductCols);
    });

    if (window.Ajaxinate && document.querySelector('#AjaxinateLoop')) {
      if (!window.__ciCollectionAjaxinate) {
        window.__ciCollectionAjaxinate = new window.Ajaxinate({
          method: 'scroll',
          container: '#AjaxinateLoop',
          pagination: '#AjaxinatePagination',
          loadingText: 'Please wait..',
          callback: () => {
            const loop = document.getElementById('AjaxinateLoop') || document;
            moveSoldOutLast(document.getElementById('AjaxinateLoop'));
            if (typeof window.initProductCardVideos === 'function') {
              window.initProductCardVideos(loop);
            }
            if (typeof window.initMerchProductCards === 'function') {
              window.initMerchProductCards(loop);
            }
          },
        });
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => initCollection());
  document.addEventListener('shopify:section:load', (event) => initCollection(event.target));
})();
